import { YN_TYPE } from "types/enumType";

/* eslint-disable max-classes-per-file */
export default interface Equipment {
  itemCode: string;
  mdmCode: string;
  code: string;
  id: number;
  name: string;
  activate: YN_TYPE;
  leftPos: number;
  topPos: number;
  width: number;
  height: number;
  image: string;
}

export class EquipmentInfo {
  itemCode: string;

  mdmCode: string;

  eqCd: string;

  code: string;

  id: number;

  name: string;

  activate: YN_TYPE;

  constructor(id: number) {
    this.itemCode = '';
    this.mdmCode = '';
    this.eqCd = '';
    this.code = '';
    this.id = id;
    this.name = '';
    this.activate = YN_TYPE.Y;
  }
}